import AppTextInput from "@jumbo/components/Common/formElements/AppTextInput";
import { Button, Grid, } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { LABEL_INPUT_FONT_SIZE, /* reformatDateYYYYmmDD */ } from "../../ConstsAndUtils/utils";
import FtCustomTable from "@jumbo/components/FtCustomTable";

import { deleteFtServEsp, getAutoridadesPorRegion, getFtServEsp, postFtServEsp, putFtServEsp, postEquipFt, getEquipft, deleteEquipFt, patchEquipFt } from "services/api";
import { EXCLUDE_FROM_ODONTOLOGIA } from "config/config";
import { toast } from "react-toastify";

import { AddBoxOutlined } from "@material-ui/icons";
import ModalAddServicePropuesta from "../ModalAddSpace/ModalAddServicePropuesta";

const estadosAux = [
    { value: 0, label: 'Seleccione' },
    { value: 1, label: 'Con autorización sanitaria' },
    { value: 2, label: 'Autorización sanitaria en tramite' },
    { value: 3, label: 'No requiere autorización sanitaria' },
]

const tiposAux = [
    { value: 0, label: 'Seleccione' },
    { value: 1, label: 'Propio' },
    { value: 2, label: 'Compra de servicios' },
]

const garantia = [
    { value: 0, label: 'Seleccione' },
    { value: 1, label: 'Si' },
    { value: 2, label: 'No' },
]

const mantencionAux = [
    { value: 0, label: 'Seleccione' },
    { value: 1, label: 'Quincenal' },
    { value: 2, label: 'Mensual' },
    { value: 3, label: 'Bimensual ' },
    { value: 4, label: 'Trimestral' },
    { value: 5, label: 'Semestral' },
    { value: 6, label: 'Anual' },
    { value: 7, label: 'Otros - Por Kms.' },
    { value: 8, label: 'Otros - Por Hrs.' },
]

const equipos = [
    "MT01 Monitor multiparámetro de signos vitales con módulo de ECG, PI, Capnógrafo, Saturómetro, PII, etc.",
    "MT02 Monitor de parametros vitales básico",
    "MT03 Monitor de Transporte",
    "MT04 Monitor Desfibrilador adulto/pediátrico",
    "MT05 Equipo de monitoreo cardiofetal",
    "MT06 Desfibrilador Automático (DEA)",
    "CX01 Máquina de anestesia",
    "CX02 Mesas Quirúrgicas",
    "CX06 Equipo de facoeresis (torre)",
    "CX07 Equipo de litrotipsia (torre)",
    "CX08 Equipo para cirugía artroscopía torre con monitor",
    "CX09 Equipo para cirugía laparóscopica torre con monitor, cámara",
    "CX10 Equipo láser de urología",
    "IM01 Ecografo (Simple/Dopler)",
    "IM02 Ecógrafo Móvil",
    "IM03 Ecocardiógrafo",
    "IM04 Equipo Arco C",
    "IM05 Electrocardiografo",
    "IM06 Equipo de Rayos x portátil",
    "IM07 Angiógrafo",
    "IM08 Angiógrafo Retinal",
    "IM09 Equipo para Densitometría ósea",
    "IM10 Ecocardiógrafo",
    "IM11 Equipo Arco C",
    "IM12 Mamógrafo",
    "IM13 Equipo Rayos X osteopulmonar",
    "IM14 Equipo Rayos X Portátil",
    "IM15 Equipo Rayos X dentales fijos",
    "IM16 Equipo Rayos X dentales móviles",
    "IM17 Resonador nuclear magnética",
    "IM18 Tomografo axial computarizado",
    "IM19 Tomografo Dental",
    "OF01 Retinógrafo",
    "OF02 Lensómetro Digital",
    "OF03 Autorefractómetro",
    "OF04 Cámara No Midriática Retinal",
    "OF05 Tomógrafo de Coherencia Óptica",
    "OF06 Topógrafo Cornéal",
    "OF07 Medidor Campo Visual Computarizado",
    "OF08 Equipo Ecobiometría",
    "PR01 Equipo para Broncoscopía",
    "PR02 Endoscopio",
    "RD01 Aceleradores Lineales Convencionales o en C",
    "RD02 Detector de radiaciones portátil",
    "RD03 Láseres de posicionamiento",
    "RD04 Monitor desfibrilador portátil, con palas adulto / pediátrico",
    "RD05 Sistema de chequeo de centraje de localizadores luminosos",
    "RD06 Sistemas en anillo",
    "RD07 Sistemas robóticos",
    "RD08 Unidad de tratamiento móvil (para radioterapia intraoperatoria o tratamientos superficiales)",
    "MN01 Cámaras gamma planas o SPECT",
    "MN02 PET-CT (Tomografía por Emisión de Positrones )",
    "MN03 PET-MR (integra imágenes metabólicas con la alta resolución de la resonancia magnética)",
    "ES01 Esterilizador por Calor Húmedo/ Autoclave de vapor",
    "ES02 Esterilizados por Óxido de Etileno",
    "ES03 Esterilizador por Plasma de Peróxido de Hidrógeno",
    "HD01 Máquina Hemodiálisis Veno-venosa Continua",
    "HD02 Monitor de Diálisis",
    "HD03 Máquina Automatizada de Peritoneodiálisis",
    "FM01 Cámara de Flujo Laminar Horizontal",
    "FM02 Cámara de Flujo Laminar Vertical",
    "FM03 Gabinetes de Bioseguridad",
    "FM04 Sistema automatizado para preparación de quimioterapia",
    "FM05 Sistema automatizado para preparación de nutriciones parenterales",
    "LB01 Analizador endocrino",
    "LB02 Analizador hematológicos",
    "LB03 Analizador hormonas",
    "LB04 Analizador química clínica",
    "LB05 Contadores hematológicos",
    "LB06 Equipo para determinación de electrolitos y gases",
    "LB07 Equipo PCR",
    "LB08 Lectores de ELISA",
    "LB09 Microscopio de fluorescencia",
    "LB10 Microscopio inmunofluorescencia",
    "LB11 Pre analítico automatizado",
    "OD01 Unidad dental fija",
    "OD02 Máquina de Óxido Nitroso",
    "OD03 Tomografía Dental (Scanner)",
    "OD04 Impresora 3D Dental",
    "CP01 Ergómetro - Test de Esfuerzo",
    "CP02 Holter de ECG",
    "CP03 Holter de Presión",
    "CP04 Equipo evaluación sistema Cardiopulmonar",
    "CP05 Equipo Función Pulmonar",
    "CP06 Equipo Plestismografía Corporal",
    "OT01 Mesa Basculante (Til-Test)",
    "OT02 Equipos para tamizaje auditivo",
    "AP01 Campana de extracción de gases y/o sistema de ventilación",
    "AP02 Centro de inclusión con placa de enfriamiento.",
    "AP03 Citocentrifuga",
    "AP04 Criostato",
    "AP05 Equipo de recuperacion antigénica",
    "AP06 Equipo inmunohistoquímica",
    "AP07 Equipo y/o sistema de tinción y de montaje de láminas",
    "AP08 Inmunotiñidor o cámara húmeda de incubación",
    "AP09 Microscopio de fluorescencia con cámara fotográfica incorporada, en sala oscura.",
    "AP10 Microscopio óptico",
    "AP11 Micrótomo",
    "AP12 Procesador de tejido automatizado",
    "AP13 Termociclador",
    "KR01 Bipedestador de Manivela",
    "KR02 Bipedestador Eléctrico",
    "KR03 Generador Onda Corta",
    "KR04 Elevador de Turbión",
    "KR05 Turbión",
    "KR06 Tanque de Inmersión",
    "KR07 Tanque de Hubbard",
    "KR08 Mesa para trabajo cuadriceps",
    "KR09 Soporte Antigravitacional",
    "KR10 Cicloergómetro: Equipo activo/asistido (bicicleta estática ajustable a las características físicas del paciente)",
    "KR11 Órtesis robótica de extremidad inferior: equipo tecnológico de rehabilitación robótica para rehabilitación de la marcha (ejemplo: lokomat, andago, argait)",
    "KR12 Órtesis robótica de extremidad superior: equipo tecnológico de rehabilitación robótica para rehabilitación de funcionalidad de la extremidad superior (ejemplo: tyronmotion, ArmMotus)",
    "KR13 Equipos de electroterapia, tales como TENS, FES, Trainfes",
    "KR14 Equipos de ultrasonido superficial y profundo",
    "KR15 Tecle eléctrico",
    "KR16 Bipedestador eléctrico con plataforma de fuerza",
    "OF01 BIOMETRIA OPTICA (IOL MASTER)",
    "OF02 TOMOGRAFIA OPTICA COMPUTARIZADA(OCT ANGIOVUE)",
    "OF03 TOPOGRAFIA(KERATOGRAPH 5M)",
    "OF04 TOMOGRAFIA OPTICA COMPUTARIZADA(OCT SPECTRALIS)",
    "OF05 CAMPIMETRO COMPUTARIZADO",
    "OF06 CAMPIMETRO GOLDMAN",
    "OF07 MICROSCOPIO ESPECULAR",
    "OF08 TOPOGRAFO ABERROMETRO",
    "OF09 TOPOGRAFO PENTACAM",
    "OF10 TOPOGRAFO REFLEXION",
    "OF11 TONOMETRO APLANATICO",
    "OF12 PAQUIMETRO",
    "OF13 PRISMAS",
    "OF14 EQUIPO TEST DE COLORES",
    "OF15 EQUIPO TEST DE LEA",
    "OF16 PROYECTOR DE OPTOTIPOS",
    "OF17 ANGIOGRAFO  DE CONTRASTE OPTOS",
    "OF18 EQUIPO TEST DE OSMOLARIDAD",
    "OF19 EQUIPO TEST MMP-9",
    "OF20 ILUX",
    "OF21 LASER IPL",
    "OF22 AUTORREFRACTOMETRO",
    "OF23 LENSOMETRO"
];


const defaultCodeList = {
    options: equipos,
    getOptionLabel: option => option,
};



const CapacidadInstaladaPropuesta = (props) => {

    const { hasCount, fields, espacios, setLoading, isEquip, dataExtra, extraCampos, isCentroDependiente, isGeneralIndiferenciada, isOdonto, datosAut } = props

    const [total, setTotal] = useState('0')
    const [agregarValue, setAgregarValue] = useState('')
    const [dataList, setDataList] = useState([])
    const [showModalCrear, setShowModalCrear] = useState(false)
    //const [editRow, setEditRow] = useState('')
    const [dataCrear, setDataCrear] = useState({})
    //const location = useLocation();
    const [autoridadesAux, setAutoridadesAux] = useState([{ value: 0, label: 'Seleccione' },])

    const [horarioCheck, seHorarioCheck] = useState(false)
    const handleChange = () => {
        seHorarioCheck(!horarioCheck)
    }


    const addSpace = () => {

        setShowModalCrear(true)
    }

    const closeModalCrear = () => {
        seHorarioCheck(false)
        setShowModalCrear(false)
    }

    useEffect(() => {

        if (hasCount) {
            let auxTotal = 0
            dataList.map((item) => {
                if (item.cantidad !== 'N/A') {
                    auxTotal += parseInt(item.cantidad)
                }

                return null
            })
            setTotal(auxTotal)
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataList])

    useEffect(() => {

        if (autoridadesAux.length > 1) {
            getData()
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoridadesAux])

    useEffect(() => {


        // setLoading(true)


        if (espacios.length >= 1) {

            // setLoading(true)
            //getData()
            getAutoridadesPorRegion(sessionStorage.getItem('region'))
                .then(res => {

                    let aux = res.data.map(item => ({
                        value: item.id,
                        label: item.nombre
                    }));
                    setAutoridadesAux([{ value: 0, label: 'Seleccione' }, ...aux])
                })
                .catch(e => console.error(e))
                .finally(f => {

                })
        } else {
            setLoading(false)
        }

        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [espacios])

    const getData = () => {

        if (isEquip) {
            getEquipft(sessionStorage.getItem('idFicha'), sessionStorage.getItem('idNav'))
                .then(res => {
                    setDataList(prepareDataEquip(res.data))
                })
                .catch(e => console.error(e))
                .finally(f => {
                    setLoading(false)
                })
        } else {
            getFtServEsp(sessionStorage.getItem('idFicha'), sessionStorage.getItem('idNav'))
                .then(res => {

                    setDataList(prepareData(res.data))
                })
                .catch(e => console.error(e))
                .finally(f => {
                    setLoading(false)
                })
        }


    }

    const reformatDate = (dateString) => {

        let dateParts = dateString.split("-");
        let reformattedDate = dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];

        return reformattedDate;
    }

    const prepareDataEquip = (data) => {

        return data.map((item, index) => {
            let foundSpace = null
            foundSpace = espacios.find(e => e.id === parseInt(item.equipamiento.id))
            let foundType = null

            if (item.id_tipo_servicio) {
                foundType = tiposAux.find(e => e.value === parseInt(item.id_tipo_servicio))
            }
            let foundEdoAutSanit = null
            if (item.id_edo_aut_sanitaria) {
                foundEdoAutSanit = estadosAux.find(e => e.value === parseInt(item.id_edo_aut_sanitaria))
            }

            let foundAutoridad = null
            if (item.id_autoridad) {
                foundAutoridad = autoridadesAux.find(e => e.value === parseInt(item.id_autoridad))
            }

            delete item.equipamiento
            delete item.id_ficha_tecnica
            delete item.id_edo_aut_sanitaria
            //delete item.id_equipamiento_medico

            let auxArr = Object.keys(item.data_extra).filter(field => {
                return field
            })

            item.garantia_vigente = !!item.garantia_vigente ? 1 : 2

            let aux = {
                ...item,
                nombre: foundSpace?.nombre || "No encontrado",
                id_tipo_servicio: foundType ? foundType.label : null,
                id_edo_aut_sanitaria: item.id_edo_aut_sanitaria ? foundEdoAutSanit.label : null,
                id_autoridad: foundAutoridad ? foundAutoridad.label : null,
                fecha_resolucion: item.fecha_resolucion ? reformatDate(item.fecha_resolucion) : '',
                nro_resolucion: item.nro_resolucion ? item.nro_resolucion : 'N/A',


            }

            auxArr.map((field) => {
                if (field === 'garantia_vigente') {
                    aux[field] = item.garantia_vigente
                } else {
                    aux[field] = item.data_extra[field]
                }

                return null
            })



            if (item.data_extra) {
                if (item.data_extra['otro_nombre']) {
                    aux = {
                        ...aux,
                        otro_nombre: item.data_extra['otro_nombre']
                    }
                }

            }

            delete aux.data_extra
            delete aux.fecha_exp_garantia
            delete aux.nro_serie

            return aux

        })
    }

    const prepareData = (data) => {

        return data.map((item, index) => {
            let foundSpace = null
            foundSpace = espacios.find(e => e.id === parseInt(item.id_espacio_medico))
            let foundType = null
            if (item.id_tipo_servicio) {
                foundType = tiposAux.find(e => e.value === parseInt(item.id_tipo_servicio))
            }
            let foundEdoAutSanit = null
            if (item.id_edo_aut_sanitaria) {
                foundEdoAutSanit = estadosAux.find(e => e.value === parseInt(item.id_edo_aut_sanitaria))
            }

            let foundAutoridad = null
            if (item.id_autoridad) {
                foundAutoridad = autoridadesAux.find(e => e.value === parseInt(item.id_autoridad))
            }

            if (dataExtra) {
                if (item.data_extra) {
                    let auxArr = Object.keys(item.data_extra).filter(field => {
                        return field
                    })

                    let aux = {
                        ...item,
                        nombre: foundSpace?.nombre || "No encontrado",
                        id_tipo_servicio: foundType ? foundType.label : null,
                        id_edo_aut_sanitaria: item.id_edo_aut_sanitaria ? foundEdoAutSanit.label : null,
                        id_autoridad: foundAutoridad ? foundAutoridad.label : null,
                        fecha_resolucion: item.fecha_resolucion ? reformatDate(item.fecha_resolucion) : '',
                        nro_resolucion: item.nro_resolucion ? item.nro_resolucion : 'N/A',
                        cantidad: item.cantidad ? item.cantidad : 'N/A',

                    }

                    auxArr.map((field) => {

                        aux[field] = item.data_extra[field] ? item.data_extra[field] : "N/A"
                        return null
                    })

                    if (item.data_extra) {
                        if (item.data_extra['otro_nombre']) {
                            aux = {
                                ...aux,
                                otro_nombre: item.data_extra['otro_nombre']
                            }
                        }

                    }

                    delete aux.data_extra

                    return aux

                } else {
                    let aux = {
                        ...item,
                        nombre: foundSpace?.nombre || "No encontrado",
                        id_tipo_servicio: foundType ? foundType.label : null,
                        id_edo_aut_sanitaria: item.id_edo_aut_sanitaria ? foundEdoAutSanit.label : null,
                        id_autoridad: foundAutoridad ? foundAutoridad.label : null,
                        fecha_resolucion: item.fecha_resolucion ? reformatDate(item.fecha_resolucion) : '',
                        nro_resolucion: item.nro_resolucion ? item.nro_resolucion : 'N/A'
                    }

                    if (item.data_extra) {
                        if (item.data_extra['otro_nombre']) {
                            aux = {
                                ...aux,
                                otro_nombre: item.data_extra['otro_nombre']
                            }
                        }

                    }
                    return aux
                }
            } else {
                let aux = {
                    ...item,
                    nombre: foundSpace?.nombre || "No encontrado",
                    id_tipo_servicio: foundType ? foundType.label : null,
                    id_edo_aut_sanitaria: item.id_edo_aut_sanitaria ? foundEdoAutSanit.label : null,
                    id_autoridad: foundAutoridad ? foundAutoridad.label : null,
                    fecha_resolucion: item.fecha_resolucion ? reformatDate(item.fecha_resolucion) : '',
                    nro_resolucion: item.nro_resolucion ? item.nro_resolucion : 'N/A',
                    nro_box: item.nro_box ? item.nro_box : 'N/A',
                    nro_camilla: item.nro_camilla ? item.nro_camilla : 'N/A'
                }


                if (item.data_extra) {
                    if (item.data_extra['otro_nombre']) {
                        aux = {
                            ...aux,
                            otro_nombre: item.data_extra['otro_nombre']
                        }
                    }

                }

                return aux
            }

        })
    }

    const postData = (data) => {

        setLoading(true)
        delete data.id
        console.log('datacre',dataCrear)
        console.log('espacios',espacios)

        let foundSpace = espacios.find(e => e.nombre === dataCrear["nombre"])

        let isOtro = false

        if (foundSpace.nombre_logico) {
            isOtro = foundSpace.nombre_logico.startsWith('otro-')
        }

        data["id_espacio_medico"] = foundSpace.id
        data["id_ficha_tecnica"] = parseInt(sessionStorage.getItem('idFicha'))
        data["id_servicio_medico"] = parseInt(sessionStorage.getItem('idNav'))
        data["otroNombre"] = isOtro ? '' : null
        data["isOtro"] = isOtro



        if (dataExtra) {
            let auxData = {}
            extraCampos.map((item, index) => {
                auxData[item] = data[item]
                return null
            })

            if (isCentroDependiente) {

                auxData = {
                    ...auxData,
                    "e_lunes_jueves": data["e_lunes_jueves"],
                    "s_lunes_jueves": data["s_lunes_jueves"],
                    "t_lunes_jueves": data["t_lunes_jueves"],
                    "e_viernes": data["e_viernes"],
                    "s_viernes": data["s_viernes"],
                    "t_viernes": data["t_viernes"],
                    "e_sabados": data["e_sabados"],
                    "s_sabados": data["s_sabados"],
                    "t_sabados": data["t_sabados"],
                    "e_domingos": data["e_domingos"],
                    "s_domingos": data["s_domingos"],
                    "t_domingos": data["t_domingos"],
                    "e_festivos": data["e_festivos"],
                    "s_festivos": data["s_festivos"],
                    "t_festivos": data["t_festivos"],
                }

                data["id_tipo_servicio"] = 1

            }

            data["data_extra"] = auxData
        }

        if (horarioCheck) {
            let auxData = {}
            auxData = {
                ...auxData,
                "e_lunes_jueves": data["e_lunes_jueves"],
                "s_lunes_jueves": data["s_lunes_jueves"],
                "t_lunes_jueves": data["t_lunes_jueves"],
                "e_viernes": data["e_viernes"],
                "s_viernes": data["s_viernes"],
                "t_viernes": data["t_viernes"],
                "e_sabados": data["e_sabados"],
                "s_sabados": data["s_sabados"],
                "t_sabados": data["t_sabados"],
                "e_domingos": data["e_domingos"],
                "s_domingos": data["s_domingos"],
                "t_domingos": data["t_domingos"],
                "e_festivos": data["e_festivos"],
                "s_festivos": data["s_festivos"],
                "t_festivos": data["t_festivos"],
            }

            //data["id_tipo_servicio"] = 1

            data["data_extra"] = auxData
        }

        if ((data.id_edo_aut_sanitaria === 2 || data.id_edo_aut_sanitaria === 3) && !isEquip) {
            delete data.nro_resolucion
            delete data.fecha_resolucion
            delete data.id_autoridad
        }

        if (isGeneralIndiferenciada && (data.nombre === 'Botiquín' || data.nombre === 'Sala rayos')) {
            delete data.nro_box
            delete data.nro_camilla
        }

        if (data.isOtro) {
            if (data['data_extra']) {
                data['data_extra'] = {
                    ...data['data_extra'],
                    otro_nombre: data.otroNombre
                }
            } else {
                data['data_extra'] = { otro_nombre: data.otroNombre }
            }

        }

        if (data.id_tipo_servicio === 2) {
            data.cantidad = 0
            data.ubicacion = "N/A"
        }

        if (isOdonto) {
            if (EXCLUDE_FROM_ODONTOLOGIA.includes(dataCrear['nombre'])) {
                delete data.n_sillones
                delete data.cantidad
            }
        }



        postFtServEsp(data)
            .then(res => {
                toast.success("Registro creado con éxito")
            })
            .catch(e => {
                console.error(e)
                toast.error("Ocurrió un error al crear registro")
            })
            .finally(f => {
                setDataCrear({})
                getData()
            })




    }

    /*     const cleanObject = (obj) => {
            return Object.fromEntries(
                Object.entries(obj).filter(([_, value]) => value !== '' && value !== 'N/A' && value !== null)
            );
        }; */

    const handleSave = (data) => {

        setLoading(true)
        let id = data.id

        if (isEquip) {
            let auxData = {
                "marca": data.marca,
                "modelo": data.modelo,
                "n_serie": data.n_serie,
                "garantia_vigente": data.garantia_vigente,
                "fecha_expiracion": data.garantia_vigente === 2 ? null : data.fecha_expiracion,
                "periodicidad_mantencion": data.periodicidad_mantencion
            }
            data["data_extra"] = auxData
            data['id_ficha_tecnica'] = parseInt(sessionStorage.getItem('idFicha'))
            data['id_servicio_medico'] = parseInt(sessionStorage.getItem('idNav'))
            data['garantia_vigente'] = data.garantia_vigente === 1 ? true : false

            if (data['fecha_resolucion'] === '') {
                delete data.fecha_resolucion
            }

            if (data.id_autoridad === "") {
                delete data.id_autoridad
            }
        }

        if (dataExtra) {
            let auxData = {}
            extraCampos.map((item, index) => {
                auxData[item] = data[item]
                return null
            })

            if (isCentroDependiente) {

                auxData = {
                    ...auxData,
                    "e_lunes_jueves": data["e_lunes_jueves"],
                    "s_lunes_jueves": data["s_lunes_jueves"],
                    "t_lunes_jueves": data["t_lunes_jueves"],
                    "e_viernes": data["e_viernes"],
                    "s_viernes": data["s_viernes"],
                    "t_viernes": data["t_viernes"],
                    "e_sabados": data["e_sabados"],
                    "s_sabados": data["s_sabados"],
                    "t_sabados": data["t_sabados"],
                    "e_domingos": data["e_domingos"],
                    "s_domingos": data["s_domingos"],
                    "t_domingos": data["t_domingos"],
                    "e_festivos": data["e_festivos"],
                    "s_festivos": data["s_festivos"],
                    "t_festivos": data["t_festivos"],
                }



            }

            data["data_extra"] = auxData
        }

        const keysToCheck = [
            "e_lunes_jueves", "s_lunes_jueves", "t_lunes_jueves",
            "e_viernes", "s_viernes", "t_viernes",
            "e_sabados", "s_sabados", "t_sabados",
            "e_domingos", "s_domingos", "t_domingos",
            "e_festivos", "s_festivos", "t_festivos"
        ];

        const hasAnyData = keysToCheck.some(key => {
            const value = data[key];
            return value !== null && value !== undefined && value !== "";
        });

        if (!dataExtra && !horarioCheck && hasAnyData) {
            let auxData = {}
            auxData = {
                ...auxData,
                "e_lunes_jueves": data["e_lunes_jueves"],
                "s_lunes_jueves": data["s_lunes_jueves"],
                "t_lunes_jueves": data["t_lunes_jueves"],
                "e_viernes": data["e_viernes"],
                "s_viernes": data["s_viernes"],
                "t_viernes": data["t_viernes"],
                "e_sabados": data["e_sabados"],
                "s_sabados": data["s_sabados"],
                "t_sabados": data["t_sabados"],
                "e_domingos": data["e_domingos"],
                "s_domingos": data["s_domingos"],
                "t_domingos": data["t_domingos"],
                "e_festivos": data["e_festivos"],
                "s_festivos": data["s_festivos"],
                "t_festivos": data["t_festivos"],
            }

            //data["id_tipo_servicio"] = 1

            data["data_extra"] = auxData
        }

        if (data.otro_nombre) {
            if (data['data_extra']) {
                data['data_extra'] = {
                    ...data['data_extra'],
                    otro_nombre: data.otro_nombre
                }
            } else {
                data['data_extra'] = { otro_nombre: data.otro_nombre }
            }

        }

        if (data.id_tipo_servicio === 2) {

            data['cantidad'] = null
            data['ubicacion'] = "N/A"
        }

        if (data['nro_box'] === "N/A") {
            data['nro_box'] = null
        }

        if (data['nro_camilla'] === "N/A") {
            data['nro_camilla'] = null
        }

        if (data['cantidad'] === "N/A") {
            data['cantidad'] = null
        }

        if (data.id_edo_aut_sanitaria === 2 || data.id_edo_aut_sanitaria === 3) {
            delete data.id_autoridad
            delete data.fecha_resolucion
            delete data.nro_resolucion
        }

        if (isOdonto) {

            if (EXCLUDE_FROM_ODONTOLOGIA.includes(data['nombre'])) {

                delete data.n_sillones
                delete data.cantidad
            }
        }


        let auxData = {
            ...data,
        }

        //const cleanedData = cleanObject(auxData)


        if (isEquip) {
            patchEquipFt(auxData, id)
                .then(res => {
                    toast.success("Actualizado con éxito")
                    getData()
                })
                .catch(e => {
                    console.error(e)
                    toast.error("Ocurrió un error al actualizar registro")
                })
                .finally(f => {
                    setLoading(false)
                })
        } else {
            putFtServEsp(auxData, id)
                .then(res => {
                    toast.success("Actualizado con éxito")
                    getData()
                })
                .catch(e => {
                    console.error(e)
                    toast.error("Ocurrió un error al actualizar registro")
                })
                .finally(f => {

                    setLoading(false)
                })
        }
    }

    const handleDelete = (id) => {

        setLoading(true)
        if (isEquip) {
            deleteEquipFt(id.id)
                .then(res => {
                    toast.success("Registro eliminado con éxito")
                })
                .catch(e => {
                    console.error(e)
                    toast.error("Ocurrió un error al eliminar registro")
                })
                .finally(f => {
                    getData()
                })
        } else {
            deleteFtServEsp(id.id)
                .then(res => {
                    toast.success("Registro eliminado con éxito")
                })
                .catch(e => {
                    console.error(e)
                    toast.error("Ocurrió un error al eliminar registro")
                })
                .finally(f => {
                    getData()
                })
        }

    }

    return (
        <>
            <Grid container item xs={12} spacing={5}> {/* normalmente este va en 5 */}


                <Grid item xs={3}>
                    <Button
                        startIcon={<AddBoxOutlined />}
                        fullWidth
                        color="primary"
                        variant="outlined"
                        style={{ marginTop: 2 }}
                        size={'small'}
                        onClick={() => {
                            addSpace()
                        }}
                    >
                        Agregar Servicio
                    </Button>
                </Grid>

            </Grid>

            <Grid container item xs={12} style={{
                marginTop: 10, marginRight: 0, marginLeft: 0,
                
            }} spacing={4}>
                <FtCustomTable
                    espacios={espacios}
                    headCells={fields}
                    rows={dataList}
                    tiposAux={tiposAux}
                    autoridadesAux={autoridadesAux}
                    estadosAux={estadosAux}
                    garantia={garantia}
                    handleSave={handleSave}
                    handleDelete={handleDelete}
                    fields={fields}
                    isEquip={isEquip}
                    dataExtra={dataExtra}
                    isCentroDependiente={isCentroDependiente}
                    isGeneralIndiferenciada={isGeneralIndiferenciada}
                    mantencionAux={mantencionAux}
                    isOdonto={isOdonto}

                />
            </Grid>

            {
                hasCount ?
                    <Grid container item xs={12} spacing={4} justifyContent="flex-end" style={{ paddingRight: 10 }}>
                        <Grid item xs={2} style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end' }}>
                            <AppTextInput
                                disabled
                                InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}

                                size="small"
                                variant="outlined"
                                label="Total"
                                value={total + ''}

                                helperText={''}
                                onBlur={() => { }}
                            />
                        </Grid>

                    </Grid>
                    :
                    null

            }
            <ModalAddServicePropuesta
                openDialog={showModalCrear}
                close={closeModalCrear}
                dataCrear={dataCrear}
                setDataCrear={setDataCrear}
                fields={fields}
                postData={postData}
                estadosAux={estadosAux}
                tiposAux={tiposAux}
                autoridadesAux={autoridadesAux}
                garantia={garantia}
                espacios={espacios}
                isEquip={isEquip}
                isCentroDependiente={isCentroDependiente}
                isGeneralIndiferenciada={isGeneralIndiferenciada}
                mantencionAux={mantencionAux}
                isOdonto={isOdonto}
                datosAut={datosAut}
                checked={horarioCheck}
                handleChange={handleChange}

            />
        </>
    )

}

export default CapacidadInstaladaPropuesta